import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export abstract class AccountRouteService {
	public abstract getRedirectUri(token: string): Observable<{ smartSyncUri: string }>;
}
